import React, { useEffect, useState } from 'react'

import { Progress, Upload } from 'antd'
import CloseCircleFillIcon from './icons/close-circle-fill-icon'
import DownloadIcon from './icons/download-icon'
import EyeFillIcon from './icons/eye-fill-icon'
import {
  showErrorMessage,
  showSuccessMessage,
} from '../../../../actions/notification'
import makeRequest from '../../../../libs/requestOther'
import moment from 'moment'
import { contentTypes } from './RenderImage'

const checkType = (url, type = '.pdf') => {
  return url.indexOf(type) !== -1
}

const getFileNamePdf = (url) => {
  if (url) {
    let string = url.substring(url.lastIndexOf('/') + 1)
    return decodeURI(string).replace(/\+/g, ' ')
  }
}

const ViewComponent = ({ file, hiddenIcon }) => {
  const getImage = async () => {
    let link = null
    let content_type = contentTypes[file?.url?.split(".").pop()];
    await makeRequest('post', `uploads/preview-file`, {
      content_type,
      url: file?.url,
      content_type,
    })
      .then(({ data }) => {
        if (data.signal) {
          link = data.data
          return data.data
        } else {
          return null
        }
      })
      .catch((err) => {
        console.log(err)
      })
    if (link) {
      window.open(link, '_blank')
    }
  }

  return (
    <a
      className='upload-list-item-thumbnail'
      onClick={() => {
        getImage()
      }}
    >
      <div className='cursor-pointer row-center f-regular_18 primary-color'>
        {hiddenIcon ? (
          <></>
        ) : (
          <div className='row-center mr-8'>
            <EyeFillIcon fill={'#338FEB'} />
          </div>
        )}
        <span>View</span>
      </div>
    </a>
  )
}

export default function UploadFileComponent({
  company_id,
  _id,
  name,
  type,
  detail_id,
  isDeleteFile,
  isReview,
  isNewReview,
  isShowDocument,
  disabled,
  setIsUpload,
  setStatus,
  isReport,
  year,
  isDocument,
  ...props
}) {
  const [file, setFile] = useState()
  const [uploading, setUploading] = useState(false)
  const [loadingImage, setLoadingImg] = useState(false)
  const [progress, setProgress] = useState(0)
  let companyId = company_id
  let maxSize = isDocument ? 500 : 100
  const beforeUploadImage = (file) => {
    let isJpgOrPng
    if (isDocument) {
      isJpgOrPng =
        file.type === 'application/pdf' ||
        file.type ===
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        file.type === 'application/doc' ||
        file.type === 'application/msword' ||
        file.type === 'application/vnd.ms-excel' ||
        file.type === 'application/vnd.ms-powerpoint' ||
        file.type === 'application/vnd.ms-powerpoint' ||
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg'
    } else {
      isJpgOrPng =
        file.type === 'application/pdf' ||
        file.type ===
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        file.type === 'application/msword' ||
        file.type === 'application/doc'
    }
    const size = file.size / 1024 / 1024

    const isLt2M = size <= maxSize
    if (!isJpgOrPng) {
      showErrorMessage({ title: 'You can only upload PDF/DOC file!' })
      return false
    } else if (!isLt2M) {
      showErrorMessage({
        title: `${props?.label ?? 'Logo'} size more than limit (100MB)`,
      })
      return false
    }
    return isJpgOrPng
  }

  const removeFileThumbnailItem = async (url) => {
    setProgress(0)
    if (setStatus) {
      setStatus(1)
    }
    // await deleteUrlLink({
    //   arrayKey: url,
    //   singleFile: true,
    // })
    if (isReport) {
      // await updateFileReport({
      //   payload: {
      //     _id: props?.value?._id,
      //     name: props?.value?.name,
      //     file_size: 0,
      //     file_url: '',
      //     year: props?.value?.year,
      //     status: props?.value?.status,
      //     company: companyId,
      //   },
      //   companyId,
      // })
    } else {
      if (file?._id && (file?.detail || detail_id)) {
        if (isDeleteFile) {
          // await updateFile({
          //   _id: _id,
          //   url: null,
          //   file_size: null,
          //   name: file?.name,
          //   type: file?.type,
          //   detail_id: file?.detail ?? detail_id,
          // })
        } else {
          // await deleteDocuments({
          //   detail_id: file?.detail ?? detail_id,
          //   document_id: file?._id,
          // })
        }
      }
    }
    if (setStatus) {
      setStatus(2)
      setTimeout(() => {
        setStatus(0)
      }, 1000)
    }
    props.onChange(null)
    setFile(null)
  }

  const uploadFile = async (options) => {
    const { file, onProgress } = options
    if (file && companyId) {
      setUploading(true)
      const config = {
        headers: { 'content-type': 'multipart/form-data' },
        onUploadProgress: (event) => {
          if (setStatus) {
            setStatus(1)
          }
          const percent = Math.floor((event.loaded / event.total) * 100)
          setProgress(percent)
          setIsUpload(true)
          if (percent === 100) {
            setTimeout(() => setProgress(0), 1000)
          }
          onProgress({ percent: (event.loaded / event.total) * 100 })
        },
      }
      const fileResponse = null
      // const fileResponse = await updateFileCompany({
      //   file: file,
      //   id: companyId,
      //   config,
      //   name,
      //   type,
      //   detail_id,
      // })

      setLoadingImg(false)
      if (setStatus) {
        setStatus(2)
        setTimeout(() => {
          setStatus(0)
        }, 1000)
      }
      if (!fileResponse?.errorCode) {
        showSuccessMessage({ title: 'Update file successfully.' })
        let isPdf = checkType(fileResponse?.url)
        let isDox =
          checkType(fileResponse?.url, '.docx') ||
          checkType(props?.value?.url, '.doc')
        let isExcel =
          checkType(fileResponse?.url, '.xls') ||
          checkType(props?.value?.url, '.xlsx')
        let isPPt = checkType(fileResponse?.url, '.ppt')
        let file_name = getFileNamePdf(fileResponse?.ur)

        let fileData = {
          url: fileResponse?.url,
          file_size: fileResponse?.file_size,
          file_name: file_name,
          isPdf: isPdf,
          isDox: isDox,
          isExcel: isExcel,
          isPPt: isPPt,
        }
        if (isReport) {
          // await updateFileReport({
          //   payload: {
          //     _id: props?.value?._id,
          //     name: props?.value?.name,
          //     file_size: fileData?.file_size,
          //     file_url: fileData?.url,
          //     year: props?.value?.year,
          //     status: props?.value?.status,
          //     company: companyId,
          //   },
          //   companyId,
          // })
        } else {
          // await updateFile({
          //   _id: _id,
          //   url: fileData?.url,
          //   file_size: fileData?.file_size,
          //   name,
          //   type,
          //   detail_id,
          // })
        }
        setIsUpload(false)
        setProgress(0)
        setFile(fileData)
        props.onChange(fileData)
      } else {
        setIsUpload(false)
        showErrorMessage({ title: fileResponse?.errorCode })
        setProgress(0)
        setFile(null)
        props.onChange(null)
      }
      setUploading(false)
    }
  }

  useEffect(() => {
    if (props?.value && props?.value?.url) {
      let isPdf = checkType(props?.value?.url)
      let isDox =
        checkType(props?.value?.url, '.docx') ||
        checkType(props?.value?.url, '.doc')
      let isExcel =
        checkType(props?.value?.url, '.xls') ||
        checkType(props?.value?.url, '.xlsx')
      let isPPt = checkType(props?.value?.url, '.ppt')
      let file_name = getFileNamePdf(props?.value?.url)
      setFile({
        ...props?.value,
        file_name,
        isPdf: isPdf,
        isDox: isDox,
        isExcel: isExcel,
        isPPt: isPPt,
      })
      setProgress(0)
    } else {
      setProgress(0)
      setFile(null)
    }
  }, [props?.value])

  return (
    <div
      style={{
        minHeight: isReview || isNewReview ? '69px' : '69px',
      }}
    >
      {(progress > 0 || file) && (
        <div
          style={{
            borderRadius: '8px',
            minWidth: '100%',
            minHeight: isReview || isNewReview ? '69px' : '69px',
            background: '#F4F7FE',
            padding: '7px 16px',
            gap: '19.29px',
          }}
        >
          {file && (
            <div
              style={{
                minWidth: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '5px 0px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  gap: '19.29px',
                  overflow: 'hidden',
                }}
                className='pr-8'
              >
                <img
                  src={
                    file?.isPdf
                      ? '/images/pdf.png'
                      : file?.isDox
                      ? '/images/doc.svg'
                      : file?.isExcel
                      ? '/images/excel.png'
                      : file?.isPPt
                      ? '/images/powerpoint.png'
                      : file.url
                  }
                  alt='images'
                  style={{
                    width: '40px',
                    height: '40px',
                  }}
                />
                <div>
                  <div
                    className='f-semibold_20 black-color limit-text-1'
                    style={{
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                      overflow: 'hidden',
                    }}
                    title={
                      file?.file_name
                        ? file?.file_name
                        : `Upload ${props?.label}`
                    }
                  >
                    {file?.file_name
                      ? file?.file_name
                      : `Upload ${props?.label}`}
                  </div>
                  {year && (
                    <span
                      style={{
                        fontSize: '14px',
                        color: '#818DAB',
                      }}
                    >
                      {year}
                    </span>
                  )}
                  {isNewReview ? (
                    isShowDocument ? (
                      <div className=''>
                        {props.value.uploaded_at && (
                          <div className='f-regular_20 color-grey-810 '>
                            Uploaded at{' '}
                            {moment(props.value.uploaded_at).format(
                              'DD/MM/YYYY'
                            )}
                          </div>
                        )}
                        {props.value.reminder && (
                          <div className='f-regular_20 color-grey-810 limit-text-1'>
                            {props.value.reminder?.name}
                          </div>
                        )}
                      </div>
                    ) : (
                      <></>
                    )
                  ) : isReview ? (
                    <div className='d-flex mt-5'>
                      {year && (
                        <span
                          className='mr-8'
                          style={{
                            fontSize: '14px',
                            color: '#818DAB',
                          }}
                        >
                          {year}
                        </span>
                      )}
                      <a
                        href={file.url}
                        target='_blank'
                        rel='noopener noreferrer'
                        download
                      >
                        <div className='cursor-pointer row-center f-regular_18 primary-color mr-10'>
                          <div className='row-center mr-8'>
                            <DownloadIcon fill={'#338FEB'} />
                          </div>
                          <span>Download</span>
                        </div>
                      </a>

                      {file?.file_size <= 100 &&
                        (file?.isDox && file?.file_size > 50 ? (
                          <></>
                        ) : file?.isDox || file?.isExcel || file?.isPPt ? (
                          <a
                            className='upload-list-item-thumbnail'
                            href={`https://view.officeapps.live.com/op/embed.aspx?src=${file.url}`}
                            target='_blank'
                            rel='noopener noreferrer'
                          >
                            <div className='cursor-pointer row-center f-regular_18 primary-color'>
                              <div className='row-center mr-8'>
                                <EyeFillIcon fill={'#338FEB'} />
                              </div>
                              <span>View</span>
                            </div>
                          </a>
                        ) : (
                          <ViewComponent file={file} />
                        ))}
                    </div>
                  ) : (
                    <div className='f-regular_18 color-grey-600 mt-5'>
                      {file?.file_size ? file?.file_size.toFixed(2) : 0}MB
                    </div>
                  )}
                </div>
              </div>
              {isNewReview ? (
                <div className='d-flex row-center'>
                  {file?.file_size <= 100 &&
                    (file?.isDox && file?.file_size > 50 ? (
                      <></>
                    ) : file?.isDox || file?.isExcel || file?.isPPt ? (
                      <a
                        className='upload-list-item-thumbnail row-center'
                        href={`https://view.officeapps.live.com/op/embed.aspx?src=${file.url}`}
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <div className='cursor-pointer row-center f-regular_18 primary-color'>
                          <span>View</span>
                        </div>
                      </a>
                    ) : (
                      <ViewComponent file={file} hiddenIcon={true} />
                    ))}
                  <a
                    href={file.url}
                    target='_blank'
                    rel='noopener noreferrer'
                    download
                    className='row-center'
                  >
                    <div className='cursor-pointer row-center f-regular_18 primary-color ml-10'>
                      <span>Download</span>
                    </div>
                  </a>
                </div>
              ) : (
                <></>
              )}
              {!disabled && (
                <div
                  className='cursor-pointer rowy-center'
                  onClick={() => removeFileThumbnailItem(file?.url)}
                >
                  <CloseCircleFillIcon />
                </div>
              )}
            </div>
          )}
          {progress > 0 && !file ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
              }}
              className='upload-custom'
            >
              <div className='width-full mr-8'>
                <div className='f-semibold_20 black-color'>Uploading...</div>
                <Progress
                  percent={progress}
                  strokeColor={'#338FEB'}
                  showInfo={false}
                />
              </div>
            </div>
          ) : null}
        </div>
      )}

      <Upload
        name='file'
        beforeUpload={beforeUploadImage}
        customRequest={uploadFile}
        showUploadList={false}
        multiple={false}
        disabled={loadingImage || disabled}
        className='upload-file-custom'
        status={'uploading'}
      >
        {!file && !uploading && (
          <div
            className={`${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
            style={{
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              minWidth: '100%',
              minHeight: isReview || isNewReview ? '69px' : '69px',
              background: '#F4F7FE',
              padding: '7px 16px',
              gap: '19.29px',
            }}
          >
            <img
              src='/images/upload-cloud-fill.svg'
              alt='images'
              style={{
                width: '40px',
                height: '40px',
              }}
            />
            <div>
              <div className='f-regular_20 color-grey-500'>
                Upload {props?.label}
              </div>
              <div className='f-regular_10 color-grey-500'>
                Maximum size: {maxSize} MB | File format: PDF, Doc
                {isDocument ? ', Excel, PPT, JPG, PNG' : ', JPG, PNG'}
              </div>
              <div className='f-regular_10 color-grey-500'>
                {isDocument
                  ? 'Only be able to view <100mb file. Otherwise please download.'
                  : ''}
              </div>
            </div>
          </div>
        )}
      </Upload>
    </div>
  )
}
